import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../providers/CustomDataProvider';
import { baseUrl, httpClient, getAuthHeaders } from '../../providers/AppDataProvider';

export const RESOURCE = 'domain-configs';
const API_PATH = 'domain-configs';

export class DomainConfigsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 50 } = params.pagination || {};
    const url = `${baseUrl}/${API_PATH}`;
    const { json } = await httpClient(url);
    const rows: any[] = json?.data ?? json?.list ?? json?.items ?? json ?? [];
    const total = json?.total ?? rows.length;
    const allData = rows.map((r: any, i: number) =>
      r?.id != null ? r : { id: `${i}`, ...r }
    );
    const start = (page - 1) * perPage;
    return { data: allData.slice(start, start + perPage), total };
  }

  // eslint-disable-next-line class-methods-use-this
  async create(_resource: string, params: { data: { domain: string } }): Promise<any> {
    const url = `${baseUrl}/${API_PATH}`;
    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify({ domain: params.data.domain }),
    });
    const data = json?.data ?? json;
    return { data: { id: data?.id ?? Date.now(), ...data } };
  }

  // eslint-disable-next-line class-methods-use-this
  async update(_resource: string, params: { id: string | number; data: { domain: string } }): Promise<any> {
    const url = `${baseUrl}/${API_PATH}/${params.id}`;
    const { json } = await httpClient(url, {
      method: 'PUT',
      body: JSON.stringify({ domain: params.data.domain }),
    });
    const data = json?.data ?? json;
    return { data: { id: params.id, ...data } };
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(_resource: string, params: { id: string | number }): Promise<any> {
    const url = `${baseUrl}/${API_PATH}/${params.id}`;
    await httpClient(url, { method: 'DELETE' });
    return { data: { id: params.id } };
  }
}

export const domainConfigsDataProvider = new DomainConfigsDataProvider();

export async function batchCreateDomainConfigs(domains: string[]): Promise<void> {
  const url = `${baseUrl}/${API_PATH}/batch`;
  await httpClient(url, {
    method: 'POST',
    body: JSON.stringify({ domains }),
  });
}

export async function importDomainConfigsCsv(file: File): Promise<void> {
  const formData = new FormData();
  formData.append('file', file);
  const headers = await getAuthHeaders();
  await fetch(`${baseUrl}/${API_PATH}/import-csv`, {
    method: 'POST',
    headers,
    body: formData,
  }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || `HTTP ${res.status}`);
    }
  });
}
